import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionButton } from '@alfa-bank/newclick-composite-components/action-button';
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import { getColorVar } from '@alfa-bank/newclick-core/utils';
import { openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import cn from 'classnames';
import { Typography } from '@alfalab/core-components/typography';
import { BubbleLinesMIcon } from '@alfalab/icons-glyph/BubbleLinesMIcon';
import { PhoneBookMIcon } from '@alfalab/icons-glyph/PhoneBookMIcon';
import { PhoneMIcon } from '@alfalab/icons-glyph/PhoneMIcon';
import { textCall } from '../../../../constants/texts';
import { useWebview } from '../../../../hooks/use-webview';
import { useWidgetContext } from '../../../../hooks/use-widget-context';
import { Page } from '../../../../types/constants';
import { VoipTextCall } from '../../shared/text-call';
import styles from './index.module.css';
export const FailedCall = ({ startCall, toggleBottomSheet }) => {
    const { platform, setDisplayPanel, trackInAnalytics, isWebview, goNext, isPreAuth, onOpenPreAuthChat, cssVarsPrefix, } = useWidgetContext();
    const { bridgeToNative } = useWebview();
    const iconColor = getColorVar({ color: 'graphicColorPrimary', prefix: cssVarsPrefix });
    const staticGraphicColorLight = getColorVar({
        color: 'staticGraphicColorLight',
        prefix: cssVarsPrefix,
    });
    const toChat = () => {
        trackInAnalytics('VOIP_TO_CHAT');
        if (isWebview) {
            bridgeToNative?.nativeNavigationAndTitle.handleNativeDeeplink('alfabank://support_chat', true);
            return;
        }
        if (isPreAuth) {
            onOpenPreAuthChat?.();
            return;
        }
        openSidePanel({ sidePanelId: 'Chat', options: {} });
    };
    const toOtherContacts = () => {
        trackInAnalytics('OTHER_CONTACTS_ON_CALL_SCREEN_BUTTON');
        if (isWebview) {
            goNext({
                sidePanelId: 'Voip',
                options: {
                    view: 'otherContacts',
                },
            });
            return;
        }
        if (platform === 'mobile' && toggleBottomSheet) {
            toggleBottomSheet();
            return;
        }
        setDisplayPanel(Page.OtherContacts);
    };
    const startCallAgain = () => {
        trackInAnalytics('VOIP_CALL_BACK');
        startCall();
    };
    return (_jsxs(SidePanel.Body, { greed: true, className: cn(styles.sidePanelBody, styles[platform], {
            [styles.webview]: isWebview,
        }), dataTestId: 'failed-call', children: [_jsx("div", { className: styles.innerWrapper, children: _jsx(VoipTextCall, { text: textCall.FAILED_CALL }) }), _jsxs("div", { className: cn(styles.sidePanelFooterInnerWrapper, styles[platform], {
                    [styles.webview]: isWebview,
                }), children: [_jsx(ActionButton.Circle, { className: cn(styles.iconButton, styles[platform], {
                            [styles.webview]: isWebview,
                        }), icon: _jsx(PhoneMIcon, { className: styles.icon, color: staticGraphicColorLight }), iconWrapperClassName: cn(styles.iconWrapper, styles.iconCall), onClick: startCallAgain, dataTestId: 'start-call-again', children: _jsx(Typography.Text, { view: 'primary-small', weight: 'regular', children: "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C" }) }), _jsx(ActionButton.Circle, { className: cn(styles.iconButton, styles[platform], {
                            [styles.webview]: isWebview,
                        }), icon: _jsx(BubbleLinesMIcon, { color: iconColor, className: styles.icon }), iconWrapperClassName: cn(styles.iconWrapper, styles.greyButton), onClick: toChat, dataTestId: 'to-chat', children: _jsx(Typography.Text, { view: 'primary-small', weight: 'regular', children: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C" }) }), _jsx(ActionButton.Circle, { className: cn(styles.iconButton, styles[platform], {
                            [styles.webview]: isWebview,
                        }), icon: _jsx(PhoneBookMIcon, { color: iconColor, className: styles.icon }), iconWrapperClassName: cn(styles.iconWrapper, styles.greyButton), onClick: toOtherContacts, dataTestId: 'to-other-contacts', children: _jsx(Typography.Text, { view: 'primary-small', weight: 'regular', children: "\u0414\u0440.\u00A0\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B" }) })] })] }));
};
